<template>
  <div class="order-page">
    <site-header />
    <main class="order-page__main">
      <div class="core-container order-page__shell">
        <nav class="order-page__breadcrumb">
          <router-link to="/">首页</router-link>
          <span>&gt;</span>
          <router-link :to="detailPath">商标详情</router-link>
          <span>&gt;</span>
          <span>确认下单</span>
        </nav>

        <div v-if="loading" class="order-page__state">
          <div class="order-page__spinner" />
          <p>加载中...</p>
        </div>

        <template v-else-if="proInfo">
          <section class="order-card">
            <div class="order-product">
              <div class="order-product__image">
                <img v-if="proInfo.cover_img" :src="proInfo.cover_img" :alt="proInfo.name || proInfo.tit" />
                <span v-else>{{ proInfo.name || proInfo.tit }}</span>
              </div>
              <div class="order-product__info">
                <h1>{{ proInfo.name || proInfo.tit }}</h1>
                <p>第{{ formatCategory(proInfo.category_id || proInfo.classify) }}类 {{ proInfo.category_name || proInfo.classify_name }}</p>
                <p class="order-product__price">售价 ¥{{ formatPrice(priceInfo.selling_price) }}</p>
              </div>
            </div>

            <div class="order-section">
              <h2>交易方式</h2>
              <div class="order-trade">
                <div class="order-trade__item is-active">
                  <strong>{{ canNotary ? '有公证' : '无公证' }}</strong>
                  <p v-if="canNotary">支付订金 → 公证 → 支付尾款 → 交付资料</p>
                  <p v-else>直接付全款 → 交付资料</p>
                </div>
              </div>
            </div>

            <div class="order-section">
              <h2>联系人信息</h2>
              <div class="order-form">
                <label>
                  <span>姓名</span>
                  <input v-model="form.buyerName" placeholder="请输入联系人姓名" />
                </label>
                <label>
                  <span>电话</span>
                  <input v-model="form.buyerPhone" type="tel" placeholder="请输入联系电话" />
                </label>
                <label>
                  <span>公司（选填）</span>
                  <input v-model="form.buyerCompany" placeholder="请输入公司名称" />
                </label>
                <label>
                  <span>备注（选填）</span>
                  <textarea v-model="form.buyerRemark" rows="3" placeholder="如有特殊要求请填写" />
                </label>
              </div>
            </div>

            <div class="order-summary">
              <div class="order-summary__row">
                <span>商标售价</span>
                <span>¥{{ formatPrice(priceInfo.selling_price) }}</span>
              </div>
              <div class="order-summary__row is-highlight">
                <span>{{ needNotary ? '本次支付（订金）' : '本次支付' }}</span>
                <span>¥{{ formatPrice(needNotary ? priceInfo.deposit_amount : priceInfo.selling_price) }}</span>
              </div>
              <div v-if="needNotary" class="order-summary__row">
                <span>待付尾款</span>
                <span>¥{{ formatPrice(priceInfo.final_amount) }}</span>
              </div>
            </div>
          </section>

          <div class="order-page__actions">
            <button
              type="button"
              class="order-page__submit"
              :disabled="submitting || paying"
              @click="submitOrder"
            >{{ submitButtonText }}</button>
          </div>
        </template>
      </div>
    </main>
    <site-footer />
  </div>
</template>

<script>
import SiteHeader from '@/components/home/SiteHeader.vue'
import SiteFooter from '@/components/home/SiteFooter.vue'
import { fetchTrademarkDetail } from '@/api/trademark'
import { calcOrderPrice, createOrder, payOrder } from '@/api/order'
import { ORDER_STATUS } from '@/constants/auth'
import { isWechatBrowser } from '@/utils/platform'

export default {
  name: 'TrademarkOrderPage',
  components: {
    SiteHeader,
    SiteFooter
  },
  data() {
    return {
      proId: '',
      loading: true,
      proInfo: null,
      priceInfo: {},
      canNotary: 0,
      needNotary: 0,
      form: {
        buyerName: '',
        buyerPhone: '',
        buyerCompany: '',
        buyerRemark: ''
      },
      submitting: false,
      paying: false
    }
  },
  computed: {
    detailPath() {
      return `/detail/${this.proId}`
    },
    submitButtonText() {
      if (this.paying) return '正在生成支付二维码...'
      if (this.submitting) return '提交中...'
      return '提交订单'
    }
  },
  created() {
    this.proId = this.$route.query.pro_id
    if (!this.proId) {
      this.$router.replace('/search')
      return
    }
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      Promise.all([
        fetchTrademarkDetail(this.proId),
        calcOrderPrice(this.proId)
      ])
        .then(([detailResult, priceResult]) => {
          if (detailResult.status === 1 && detailResult.data) {
            this.proInfo = detailResult.data
          }
          if (priceResult.status === 1 && priceResult.data) {
            this.priceInfo = priceResult.data
            this.canNotary = Number(priceResult.data.can_notary)
            this.needNotary = this.canNotary
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    submitOrder() {
      if (!this.form.buyerName.trim()) {
        window.alert('请填写联系人姓名')
        return
      }
      if (!this.form.buyerPhone.trim()) {
        window.alert('请填写联系电话')
        return
      }
      if (!/^1[3-9]\d{9}$/.test(this.form.buyerPhone.trim())) {
        window.alert('请输入正确的手机号')
        return
      }

      this.submitting = true
      const inviterId = localStorage.getItem('saas_inviter_id') || 0

      createOrder({
        pro_id: this.proId,
        need_notary: this.needNotary,
        buyer_name: this.form.buyerName.trim(),
        buyer_phone: this.form.buyerPhone.trim(),
        buyer_company: this.form.buyerCompany.trim(),
        buyer_remark: this.form.buyerRemark.trim(),
        inviter_id: inviterId
      })
        .then(result => {
          if (result.status !== 1 || !result.data) {
            window.alert(result.desc || result.msg || '创建订单失败')
            return
          }
          this.startPayment(result.data)
        })
        .catch(() => {
          window.alert('创建订单失败，请重试')
        })
        .finally(() => {
          this.submitting = false
        })
    },
    startPayment(order) {
      const isDeposit = Number(order.need_notary) === 1
      const amount = isDeposit ? order.deposit_amount : order.selling_price
      const type = isDeposit ? 'deposit' : 'full'

      this.paying = true
      payOrder({ order_no: order.order_no, amount, type })
        .then(result => {
          if (result.status !== 1 || !result.data || !result.data.qrCodeUrl) {
            window.alert(result.desc || result.msg || '获取支付二维码失败，请前往我的订单重试')
            this.$router.push('/my-orders')
            return
          }

          const qrCodeUrl = result.data.qrCodeUrl
          if (isWechatBrowser()) {
            window.location.href = qrCodeUrl
            return
          }

          this.$store.commit('SHOW_PAYMENT', {
            qrUrl: qrCodeUrl,
            orderNo: order.order_no,
            orderStatus: ORDER_STATUS.PENDING,
            payAmount: amount
          })
        })
        .catch(() => {
          window.alert('网络错误，请前往我的订单重试')
          this.$router.push('/my-orders')
        })
        .finally(() => {
          this.paying = false
        })
    },
    formatCategory(id) {
      return String(id).padStart(2, '0')
    },
    formatPrice(price) {
      if (!price || price <= 0) return '0'
      return Math.round(price).toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.order-page {
  min-height: 100vh;
  background: var(--color-bg-main);
}

.order-page__main {
  padding: var(--space-lg) 0 var(--space-xl);
}

.order-page__breadcrumb {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  margin-bottom: var(--space-lg);
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.order-page__state {
  min-height: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--color-text-muted);
}

.order-page__spinner {
  width: 40px;
  height: 40px;
  border: 3px solid var(--color-border-light);
  border-top-color: var(--color-primary);
  border-radius: 50%;
  animation: order-spin 0.8s linear infinite;
  margin-bottom: var(--space-md);
}

.order-card {
  background: var(--color-bg-page);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-panel);
  padding: var(--space-xl);
}

.order-product {
  display: flex;
  gap: var(--space-lg);
  padding-bottom: var(--space-lg);
  border-bottom: 1px solid var(--color-border-light);
}

.order-product__image {
  width: 120px;
  height: 120px;
  border-radius: var(--radius-md);
  overflow: hidden;
  background: var(--color-bg-main);
  display: flex;
  align-items: center;
  justify-content: center;
}

.order-product__image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.order-product__info h1 {
  font-size: var(--font-size-xl);
  margin-bottom: var(--space-sm);
}

.order-product__price {
  margin-top: var(--space-md);
  font-size: var(--font-size-xl);
  color: var(--color-price);
  font-weight: 700;
}

.order-section {
  padding: var(--space-lg) 0;
  border-bottom: 1px solid var(--color-border-light);
}

.order-section h2 {
  margin-bottom: var(--space-md);
  font-size: var(--font-size-lg);
}

.order-trade__item {
  padding: var(--space-md);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-primary-light);
}

.order-form {
  display: grid;
  gap: var(--space-md);
}

.order-form label {
  display: grid;
  gap: var(--space-sm);
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.order-form input,
.order-form textarea {
  width: 100%;
  padding: var(--space-sm) var(--space-md);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  font-size: var(--font-size-md);
  outline: none;
}

.order-form input:focus,
.order-form textarea:focus {
  border-color: var(--color-primary);
}

.order-summary {
  padding-top: var(--space-lg);
  display: grid;
  gap: var(--space-sm);
}

.order-summary__row {
  display: flex;
  justify-content: space-between;
  font-size: var(--font-size-md);
}

.order-summary__row.is-highlight {
  color: var(--color-price);
  font-weight: 700;
}

.order-page__actions {
  margin-top: var(--space-lg);
  display: flex;
  justify-content: center;
}

.order-page__submit {
  min-width: 200px;
  padding: var(--space-md) var(--space-2xl);
  border: none;
  border-radius: var(--radius-pill);
  background: var(--color-price);
  color: var(--color-text-inverse);
  font-size: var(--font-size-md);
}

.order-page__submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@keyframes order-spin {
  to { transform: rotate(360deg); }
}
</style>
